import { getContext } from '@picsart/miniapps-sdk';

import applyMobileCanvasSizeLimit from 'pages/Batch/utils/applyMobileCanvasSizeLimit';

type Size = { width: number; height: number };

const getImageSize = (width: number, height: number): Size => {
  const isWeb = getContext().handlers.isWeb();

  if (isWeb) {
    return { width, height };
  }

  return applyMobileCanvasSizeLimit(width, height);
};

export default getImageSize;
